import { useContext, FC } from 'react'

import { entitiesSummary } from './contants/entitiesSummary'
import { globalSummary } from './contants/globalSummary'
import { pathsSummary } from './contants/pathsSummary'
import SummaryManagerContext from './Context'
import { formatSummaryTextsBySummaryObject } from './utils/formatSummaryTextsBySummaryObject'
import { Summary } from './types'

type Props = {
  children: JSX.Element
}

const SummaryManagerProvider: FC<Props> = ({ children }) => {
  const summary: Summary = {
    entities: formatSummaryTextsBySummaryObject(entitiesSummary),
    global: formatSummaryTextsBySummaryObject(globalSummary),
    paths: formatSummaryTextsBySummaryObject(pathsSummary),
  }

  return <SummaryManagerContext.Provider value={{ summary }}>{children}</SummaryManagerContext.Provider>
}

export const useSummaryManager = () => useContext(SummaryManagerContext)

export default SummaryManagerProvider
